module.exports = __webpack_public_path__ + "img/orange_113.a808e1c7.png";